import "../App.css";
import React, { useEffect } from "react";

import Header from "../components/Header";
import Carousel from "../components/Carousel";
import RaveSection from "../components/RaveSection";
import Card from "../components/Card";
import Footer from "../components/Footer";

export default function Home() {
  useEffect(() => {
    document.title = "STUNNER RAVE | HOME";
  }, []);

  return (
    <main className="w-full">
      <Header />
      <Carousel />
      <div className="relative z-40 bg-white">
        <RaveSection />
        <Card limit={3} />
        <Footer />
      </div>
    </main>
  );
}
